import { useEffect, useState } from 'react'
import { Bottone } from '../../componenti/base.tsx'
import { IconaAvviso, IconaRipristina } from '../../componenti/Icone.tsx'
import * as posta from '../../servizi/posta.ts'

/**
 * «È indesiderata» e «Non è indesiderata» nella conversazione aperta (542, decisione di Davide del
 * 2/11/2026), come in Roundcube. Il comando giusto lo dice l'API (GET /posta/thread/:id/indesiderata): nessuno
 * se la conversazione non ha messaggi ricevuti, se la casella non e' ospitata o se non si ha l'accesso pieno.
 * Premuto, sposta i messaggi ricevuti e insegna all'antispam di mx1cidis; chi lo usa riceve `spostata` per
 * togliere la conversazione dall'elenco e aggiornare le cartelle.
 */
export function ComandoIndesiderata({ threadId, attivo, spostata, errore }: {
  threadId: string
  /** Falso con la sola lettura, in supervisione, impersonando: il comando non si chiede nemmeno. */
  attivo: boolean
  spostata: (indesiderata: boolean) => void
  errore: (e: unknown) => void
}) {
  const [comando, setComando] = useState<posta.ComandoIndesiderata | null>(null)
  const [inCorso, setInCorso] = useState(false)

  useEffect(() => {
    setComando(null)
    if (!attivo) return
    let valido = true
    posta.comandoIndesiderata(threadId)
      .then((r) => { if (valido) setComando(r.comando) })
      .catch(() => undefined)
    return () => { valido = false }
  }, [threadId, attivo])

  if (!comando) return null
  const indesiderata = comando === 'segna'

  async function esegui() {
    setInCorso(true)
    try {
      await posta.segnaIndesiderata(threadId, indesiderata)
      spostata(indesiderata)
    } catch (e) { errore(e) } finally { setInCorso(false) }
  }

  return (
    <Bottone variante="discreto" dimensione="piccolo" inCorso={inCorso}
             icona={indesiderata ? <IconaAvviso /> : <IconaRipristina />}
             title={indesiderata
               ? 'Sposta i messaggi ricevuti nella cartella Indesiderata e insegna al filtro antispam che è posta indesiderata'
               : 'Riporta i messaggi ricevuti nella Posta in arrivo e insegna al filtro antispam che non è posta indesiderata'}
             onClick={() => void esegui()}>
      {indesiderata ? 'È indesiderata' : 'Non è indesiderata'}
    </Bottone>
  )
}
